__turbopack_context__.v({
  "closeButton": "ILh5ea_closeButton",
  "content": "ILh5ea_content",
  "flag": "ILh5ea_flag",
  "isClosing": "ILh5ea_isClosing",
  "linkWrapper": "ILh5ea_linkWrapper",
  "text": "ILh5ea_text",
});
